const inqMethods = [
  {
    type: 'mail',
    title: 'メール',
    icon: ['fas', 'fa-envelope'],
  },
  {
    type: 'line',
    title: 'LINE',
    icon: ['fab', 'fa-line'],
  },
  {
    type: 'tel',
    title: '電話',
    icon: ['fas', 'fa-phone'],
  },
]

const app = new Vue({
  el: '#page',
  components: {
    Hooper: window.Hooper.Hooper,
    Slide: window.Hooper.Slide,
    HooperNavigation: window.Hooper.Navigation,
  },
  data: {
    hooperSettings: {
      autoPlay: true,
      trimWhiteSpace: true,
      playSpeed: 3000,
      transition: 500,
      infiniteScroll: true,
      itemsToShow: 2,
      wheelControl: false,
      breakpoints: {
        680: { itemsToShow: 4 },
        1216: { itemsToShow: 6 },
      },
      centerMode: true,
    },
    flowType: 'flow-shop',
    inqMethods,
    activeInqMethod: inqMethods[0],
    isActiveCourierModal: false,
    isMailSend: false,
  },
  methods: {
    closeCourierModal() {
      this.isActiveCourierModal = false
    },
    openCourierModal() {
      this.isMailSend = false
      this.isActiveCourierModal = true
    },
  },
  mounted() {
    document.addEventListener('wpcf7mailsent', () => {
      this.isMailSend = true
    }, false)
  },
})
